/*
 * @Description: 
 * @Author: 赵大壮
 * @Date: 2024-07-21 17:04:05
 * @LastEditTime: 2024-07-23 13:24:38
 * @LastEditors: 赵大壮
 */
import config from '../nyConfig'
const ApiBanner = {
    "添加Banner": new config({ url: '/banner/addBanner', showSuccessMessage: true, useToken: true }),
    "编辑Banner": new config({ url: '/banner/editBanner', showSuccessMessage: true, useToken: true }),
    "删除Banner": new config({ url: '/banner/delBanner', showSuccessMessage: true, useToken: true }),
    "Banner列表": new config({ url: '/banner/listBanner', showSuccessMessage: false, useToken: true }),
    "修改Banner排序": new config({ url: '/banner/saveSort', showSuccessMessage: true, useToken: true }),
    "添加商城Banner": new config({ url: '/banner/addStoreBanner', showSuccessMessage: true, useToken: true }),
    "编辑商城Banner": new config({ url: '/banner/editStoreBanner', showSuccessMessage: true, useToken: true }),
    "删除商城Banner": new config({ url: '/banner/delStoreBanner', showSuccessMessage: true, useToken: true }),
    "商城Banner列表": new config({ url: '/banner/listStoreBanner', showSuccessMessage: false, useToken: true }),
    "修改商城Banner排序": new config({ url: '/banner/saveStoreSort', showSuccessMessage: true, useToken: true }),
    "Banner数据上移": new config({ url: '/banner/moveUp', showSuccessMessage: true, useToken: true }),
    "Banner数据下移": new config({ url: '/banner/moveDown', showSuccessMessage: true, useToken: true }),
    "Banner数据置顶": new config({ url: '/banner/moveTop', showSuccessMessage: true, useToken: true }),
    "Banner取消置顶": new config({ url: '/banner/cancelTop', showSuccessMessage: true, useToken: true }),
    "商城Banner数据上移": new config({ url: '/banner/storeMoveUp', showSuccessMessage: true, useToken: true }),
    "商城Banner数据下移": new config({ url: '/banner/storeMoveDown', showSuccessMessage: true, useToken: true }),
    "商城Banner数据置顶": new config({ url: '/banner/storeMoveTop', showSuccessMessage: true, useToken: true }),
    "商城Banner取消置顶": new config({ url: '/banner/storeCancelTop', showSuccessMessage: true, useToken: true }),
}

export default ApiBanner